import { message } from 'antd';
import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects';

import {
    FETCH_PUBLIC_TEMPLATES,
    FETCH_PUBLIC_TEMPLATES_START,
    FETCH_PUBLIC_TEMPLATES_SUCCESS,
    FETCH_PUBLIC_TEMPLATES_ERROR,
    ADD_UPDATE_PUBLIC_TEMPLATE_START,
    ADD_UPDATE_PUBLIC_TEMPLATE_SUCCESS,
    ADD_UPDATE_PUBLIC_TEMPLATE_ERROR,
    ADD_UPDATE_PUBLIC_TEMPLATE,
    DELETE_PUBLIC_TEMPLATE_START,
    DELETE_PUBLIC_TEMPLATE_SUCCESS,
    DELETE_PUBLIC_TEMPLATE_ERROR,
    DELETE_PUBLIC_TEMPLATE
} from "../../actions/guildlibrarian/publicTemplatesAction";
import { getAllCategorizedPublicTemplatesAPI, addUpdatePublicTemplateAPI, deletePublicTemplateAPI } from '../../../services/public-templates-service';

function* fetchPublicTemplates({ }) {
    try {
        yield put({ type: FETCH_PUBLIC_TEMPLATES_START })
        const response = yield call(getAllCategorizedPublicTemplatesAPI);
        if (response.success) {
            yield put({ type: FETCH_PUBLIC_TEMPLATES_SUCCESS, publicTemplates: response.publicTemplates })
        } else {
            yield put({ type: FETCH_PUBLIC_TEMPLATES_ERROR, error: response.error })
            message.error('Failed to fetch public templates!');
        }
    } catch (error) {
        yield put({ type: FETCH_PUBLIC_TEMPLATES_ERROR, error })
        message.error('Failed to fetch public templates!');
    }
}

function* addUpdatePublicTemplate({ publicTemplate }) {
    try {
        yield put({ type: ADD_UPDATE_PUBLIC_TEMPLATE_START })
        const response = yield call(addUpdatePublicTemplateAPI, publicTemplate);
        if (response.success) {
            yield put({ type: ADD_UPDATE_PUBLIC_TEMPLATE_SUCCESS, template: response.template })
            message.success('Template saved successfully!');
        } else {
            if (response.error) {
                yield put({ type: ADD_UPDATE_PUBLIC_TEMPLATE_ERROR })
                message.error(response.error);
            } else {
                yield put({ type: ADD_UPDATE_PUBLIC_TEMPLATE_ERROR })
                message.error('Failed to save!');
            }
        }
    } catch (error) {
        yield put({ type: ADD_UPDATE_PUBLIC_TEMPLATE_ERROR })
        message.error('Failed to save!');
    }
}

function* deletePublicTemplate({ publicTemplate }) {
    try {
        const { id, name } = publicTemplate;
        yield put({ type: DELETE_PUBLIC_TEMPLATE_START})
        const response = yield call(deletePublicTemplateAPI, id, name);
        if (response.success) {
            yield put({ type: DELETE_PUBLIC_TEMPLATE_SUCCESS, template: publicTemplate })
            message.success('Template deleted successfully!');
        } else {
            if (response.error) {
                yield put({ type: DELETE_PUBLIC_TEMPLATE_ERROR })
                message.error(response.error);
            } else {
                yield put({ type: DELETE_PUBLIC_TEMPLATE_ERROR })
                message.error('Failed to delete!');
            }
        }
    } catch (error) {
        yield put({ type: DELETE_PUBLIC_TEMPLATE_ERROR })
        message.error('Failed to delete!');
    }
}

function* publicTemplatesWatcher() {
    yield takeEvery(FETCH_PUBLIC_TEMPLATES, fetchPublicTemplates)
    yield takeLatest(ADD_UPDATE_PUBLIC_TEMPLATE, addUpdatePublicTemplate)
    yield takeLatest(DELETE_PUBLIC_TEMPLATE, deletePublicTemplate)
}

export default function* rootSaga() {
    yield all([
        publicTemplatesWatcher(),
    ]);
}